import React, { Component } from 'react'
//import logo from './logo.svg'
import {
  Button,
  Grid,
  Row,
  Col,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap'
import Big from 'big.js'
import './App.css'

class App extends Component {
  constructor() {
    super()
    this.state = {
      A: 0,
      B: 0,
      C: 0,
      D: 0,
      tempD: '0',
      E: 0,
      F: 0,
      DM: 0,
      M: 0,
      G: 0,
      tempG: '0',
      H: 0,
      I: 0,
    }
  }

  getValidationStateF = () => {
    if (this.state.F < 0) return 'error'
    if (this.state.F > 500000) return 'error'
    if (this.state.F === 0) return 'warning'
    else return 'success'
  }

  getValidationStateG = () => {
    if (+this.state.tempG < 1) return 'error'
    if (isNaN(+this.state.tempG)) return 'error'
    if (+this.state.tempG > 10) return 'error'
    //if (+this.state.tempG === 0) return 'warning'
    else return 'success'
  }

  getValidationStateB = () => {
    if (this.state.B < 0) return 'error'
    if (this.state.B > 50) return 'error'
    if (this.state.B === 0) return 'error'
    else return 'success'
  }

  getValidationStateD = () => {
    //if (+this.state.tempD < 0) return 'error'
    if (+this.state.tempD < 0.1) return 'error'
    if (isNaN(+this.state.tempD)) return 'error'
    if (+this.state.tempD > 10) return 'error'
    if (+this.state.tempD === 0) return 'warning'
    else return 'success'
  }

  getFullValid = () => {
    if (
      this.getValidationStateF() === 'success' &&
      this.getValidationStateG() === 'success' &&
      this.getValidationStateB() === 'success' &&
      this.getValidationStateD() === 'success'
    )
      return true
    else return false
    //return true
  }

  onClick = () => {
    //Valid all fields
    //if (!this.getFullValid()) return

    // assign tempD to D
    //this.onChangeD(+this.state.tempD)
    const d = new Big(+this.state.tempD)
    const dm = d.div(12).div(100)

    this.setState({
      D: +this.state.tempD,
      DM: +dm.toFixed(5),
    })

    //check all values range
    let f = new Big(this.state.F)
    //let dm = new Big(this.state.DM)

    //e is string!!
    const e = f
      .times(dm)
      .times(10000)
      .round()

    const m = (this.state.B - this.state.C) * 12

    //console.log('m', m)

    let onePlusDMTimesDM = dm
      .plus(1)
      .pow(m)
      .times(dm)

    //console.log('onePlusDMTimesDM', onePlusDMTimesDM.toFixed(5))
    // .pow(m)
    // .times(dm)

    let onePlusDMMinusOne = dm
      .plus(1)
      .pow(m)
      .minus(1)
    // .pow(m)
    // .minus(1)

    //console.log('onePlusDMMinusOne', onePlusDMMinusOne.toFixed(5))

    const a = onePlusDMMinusOne
      .div(onePlusDMTimesDM)
      .times(f)
      .round()

    const g = Big(+this.state.tempG)
    const h = a.div(g).times(10)
    const i = h.minus(a)

    this.setState({
      E: +e,
      A: +a,
      M: m,
      G: +g,
      I: +i,
      H: +h,
    })
  }

  onChangeD = value => {
    if (!value) return

    const d = new Big(value)
    const dm = d.div(12).div(100)

    this.setState({
      D: value,
      DM: +dm.toFixed(5),
    })
  }

  render() {
    let disabled = true
    if (this.getFullValid()) disabled = false

    return (
      <div className="App">
        <Grid>
          <Row>
            <Col md={6} mdPush={6}>
              <Form horizontal>
                <FormGroup
                  controlId="formHorizontalA"
                  validationState={this.getValidationStateF()}
                >
                  <Col componentClass={ControlLabel} sm={6}>
                    預計每月還款金額(元)
                  </Col>
                  <Col sm={6}>
                    <FormControl
                      type="text"
                      value={this.state.F}
                      placeholder=""
                      onChange={e => {
                        if (
                          typeof +e.target.value === 'number' &&
                          !isNaN(+e.target.value)
                        ) {
                          this.setState({
                            F: +e.target.value,
                          })
                        }
                      }}
                    />
                    <FormControl.Feedback />
                  </Col>
                  <HelpBlock>1~500000 整數</HelpBlock>
                </FormGroup>
                <FormGroup
                  controlId="formHorizontalB"
                  validationState={this.getValidationStateG()}
                >
                  <Col componentClass={ControlLabel} sm={6}>
                    貸款成數
                  </Col>
                  <Col sm={6}>
                    <FormControl
                      type="text"
                      value={this.state.tempG}
                      placeholder=""
                      onChange={e => {
                        this.setState({
                          tempG: e.target.value,
                        })
                      }}
                    />
                    <FormControl.Feedback />
                  </Col>
                  <HelpBlock>1~10數字(例如：欲貸款八五成，請輸入8.5)</HelpBlock>
                </FormGroup>
                <FormGroup
                  controlId="formHorizontalC"
                  validationState={this.getValidationStateB()}
                >
                  <Col componentClass={ControlLabel} sm={6}>
                    貸款年限(年)
                  </Col>
                  <Col sm={6}>
                    <FormControl
                      type="text"
                      value={this.state.B}
                      placeholder=""
                      onChange={e => {
                        if (
                          typeof +e.target.value === 'number' &&
                          !isNaN(+e.target.value)
                        ) {
                          this.setState({
                            B: +e.target.value,
                          })
                        }
                      }}
                    />
                    <FormControl.Feedback />
                  </Col>
                  <HelpBlock>1~50 整數</HelpBlock>
                </FormGroup>
                <FormGroup
                  controlId="formHorizontalD"
                  validationState={this.getValidationStateD()}
                >
                  <Col componentClass={ControlLabel} sm={6}>
                    貸款年利率(%百分比)
                  </Col>
                  <Col sm={6}>
                    <FormControl
                      type="text"
                      value={this.state.tempD}
                      placeholder=""
                      onChange={e => {
                        this.setState({
                          tempD: e.target.value,
                        })
                      }}
                    />
                    <FormControl.Feedback />
                  </Col>
                  <HelpBlock>0.1~10數字(例如：1.56%利息，則輸入1.56)</HelpBlock>
                </FormGroup>
                <div>
                  <Button
                    bsStyle="primary"
                    onClick={this.onClick}
                    disabled={disabled}
                  >
                    立即計算
                  </Button>
                </div>
              </Form>
            </Col>

            <Col md={6} mdPull={6}>
              <h1>本息平均攤還法</h1>
              在利率不變的條件下，每月攤還本金與利息的總合固定，
              <br />
              對於還款預算較易掌握
              <br />
              可購買的房屋總價為{' '}
              <span style={{ color: 'red' }}>
                {~~(this.state.H / 10000)}
              </span>{' '}
              萬元。
              <br />
              需準備頭期款金額為{' '}
              <span style={{ color: 'red' }}>
                {~~(this.state.I / 10000)}
              </span>{' '}
              萬元。
              <br />
              貸款金額為{' '}
              <span style={{ color: 'red' }}>
                {~~((this.state.H - this.state.I) / 10000)}
              </span>{' '}
              萬元。
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js